var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 28"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M11.213 5.925a.875.875 0 0 1 1.237.038l7 7.437a.875.875 0 0 1 0 1.2l-7 7.437a.875.875 0 0 1-1.275-1.2L17.611 14l-6.436-6.838a.875.875 0 0 1 .038-1.237",
  clipRule: "evenodd"
})));
export default SvgIconArrow;